var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:twotone-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6667 17.4167H18.7121L18.3738 17.0904C19.5989 15.6694 20.2722 13.8553 20.2708 11.9792C20.2708 10.4258 19.8102 8.90724 18.9472 7.61563C18.0841 6.32402 16.8575 5.31733 15.4223 4.72287C13.9872 4.1284 12.408 3.97286 10.8844 4.27592C9.36084 4.57897 7.96136 5.32701 6.86294 6.42544C5.76451 7.52386 5.01647 8.92334 4.71342 10.4469C4.41036 11.9705 4.5659 13.5497 5.16037 14.9848C5.75483 16.42 6.76152 17.6466 8.05313 18.5097C9.34474 19.3727 10.8633 19.8333 12.4167 19.8333C14.3621 19.8333 16.1504 19.1204 17.5279 17.9363L17.8542 18.2746V19.2292L23.8958 25.2588L25.6963 23.4583L19.6667 17.4167ZM12.4167 17.4167C9.40792 17.4167 6.97917 14.9879 6.97917 11.9792C6.97917 8.97042 9.40792 6.54167 12.4167 6.54167C15.4254 6.54167 17.8542 8.97042 17.8542 11.9792C17.8542 14.9879 15.4254 17.4167 12.4167 17.4167Z",
    fill: "#161718"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f591c72e919fd1533edfb89901f339a3.svg";
export { ForwardRef as ReactComponent };